import React from 'react';

const Page404 = () => {
    return (
        <div>
            <img className='w-100' src="/page404.png" alt="" />
        </div>
    );
};

export default Page404;